import { render, staticRenderFns } from "./EmailProperties.vue?vue&type=template&id=b1b326e0&scoped=true&"
import script from "./EmailProperties.vue?vue&type=script&lang=js&"
export * from "./EmailProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b326e0",
  null
  
)

export default component.exports